import * as _ from 'lodash'
import {PaymentTypeBO} from "./PaymentTypeBO";
import {MessageType} from "../PA.Core/PA.Core.IF.Basic";


export class PaymentTypeBOValidations {

  static async ValidateEmptyFields(aBO: PaymentTypeBO): Promise<void> {

      // Valid Payment Type ID
      if (_.isEmpty(aBO.WB_PaymentType.cif.PAYMENT_TYPE_ID) || _.isNull(aBO.WB_PaymentType.cif.PAYMENT_TYPE_ID)) {
        aBO.ValidateMessageProvider.addMessage(
          {
            code: 'EmptyId',
            type: MessageType.Error,
            title: "Payment Type ID cannot be empty",
            description: "",
            subtitle: "",
            count: 0
          })
      } else {
        aBO.ValidateMessageProvider.removeMessage('EmptyId')
      }

      if (_.isEmpty(aBO.WB_PaymentType.cif.PAYMENT_TYPE_NAME)) {
        aBO.ValidateMessageProvider.addMessage(
          {
            code: 'EmptyName',
            type: MessageType.Error,
            title: "Payment Type Name cannot be empty",
            description: "",
            subtitle: "",
            count: 0
          })
      } else {
        aBO.ValidateMessageProvider.removeMessage('EmptyName')
      }
  }
}

